import React from 'react';
import { useQuery, useMutation } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Text, Button, VStack, HStack, useToast, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from '@chakra-ui/react';
import AuctionService from '../../services/AuctionService';
import CustomSpinner from './CustomSpinner';
import Api from '../../api/ApiUrl'

const ViewLosers = () => {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedLoserId, setSelectedLoserId] = React.useState(null);
  const onClose = () => setIsOpen(false);
  const cancelRef = React.useRef();

  const { data, isLoading, error } = useQuery(['losers', itemId], () => AuctionService.fetchWinnersOrLosers(itemId, 'loser'));

  const mutation = useMutation((params) => AuctionService.performAdminAction(params.loserId, 'delete'), {
    onSuccess: () => {
      toast({
        title: 'Delete action performed successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    //   refetch();
    },
    onError: () => {
      toast({
        title: 'Error performing delete action',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });

  const handleDelete = (loserId) => {
    setSelectedLoserId(loserId);
    setIsOpen(true);
  };

  const confirmDelete = () => {
    mutation.mutate({ loserId: selectedLoserId });
    setIsOpen(false);
  };

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <Box>Error loading losers.</Box>;
  }

  return (
    <Box maxW="5xl" mx="auto" p={4}>
      <Text fontSize="2xl" mb={4}>Losers</Text>
      {data.data.map((loser) => (
        <VStack key={loser._id} p={4} border="1px" borderColor="gray.200" borderRadius="md" align="start" spacing={4}>
          <Text><strong>User Name:</strong> {loser.userId.name}</Text>
          <Text><strong>Phone :</strong> {loser.userId.phoneNumber}</Text>
          <Text><strong>Amount:</strong> {loser.amount}</Text>
          <Text><strong>Status:</strong> {loser.status}</Text>
          <HStack spacing={4}>
            <Button colorScheme="red" onClick={() => handleDelete(loser._id)}>Delete</Button>
          </HStack>
        </VStack>
      ))}

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Delete
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this loser?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default ViewLosers;
